import {Button, Modal, ModalBody, ModalFooter} from "reactstrap";
import React from "react";

class DeleteConfirm extends React.Component{

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render(){

        let {form} = this.props;

        return (
            <Modal isOpen={form.state.deleteConfirmModal} toggle={form.toggleModal} className={'delete-modal'}>
                <ModalBody>
                    <div className={'modal-delete-header'}>
                        <span>Delete Records?</span>
                    </div>
                    <div className={'modal-delete-content'}>
                                            <span>
                                                {this.props.deleteMsg}
                                            </span>
                        <span className={'hide'}>Do you want to delete the {form.state.massSelect.length > 1 ? form.state.massSelect.length + ' selected records?' : 'record'}</span>
                    </div>
                    <Modal isOpen={form.state.nestedModal} toggle={form.toggleNestedModal} onClosed={form.state.closeAll ? form.toggleModal : undefined}>
                        <ModalBody><div dangerouslySetInnerHTML={{ __html: form.state.forceErrorMsg }} ></div></ModalBody>
                        <ModalFooter>
                            <button className={'btn-wide mb-2 me-2 btn-pill btn btn-light'} onClick={form.toggleAllModal}>
                                No
                            </button>
                            <button className={'btn-wide mb-2 me-2 btn-pill btn btn-danger'} onClick={(e) => {this.props.onDelete(e, true, true)}}>
                                Yes
                            </button>{" "}
                        </ModalFooter>
                    </Modal>
                </ModalBody>
                <ModalFooter>
                    <Button className="btn-wide mb-2 me-2 btn-pill" color="light" onClick={form.toggleModal}>
                        Cancel
                    </Button>
                    <Button  className="btn-wide mb-2 me-2 btn-pill" color="danger" onClick={(e) => {this.props.onDelete(e, true)}}>
                        Delete
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}


export default DeleteConfirm;
